import React from "react";
import VideoBoxGrid from "../components/video_box_grid";
import styles from "./onlinetv_more_video.module.scss";

export const OnlinetvMoreVideo = () => {
  return (
    <section className={styles.section_more_blog}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2>More Video</h2>
        </div>
        <div className={styles.video_grid_wrapper}>
          {new Array(12).fill(1).map((course, i) => (
            <VideoBoxGrid key={i} metaBottom showCategory />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OnlinetvMoreVideo;
